import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VListItem,[_c(VListItemAvatar,{attrs:{"tile":""}},[_c('span',{staticClass:"titleZh"},[_vm._v(_vm._s(_vm.character))])]),_c(VListItemContent,[_c(VListItemTitle,{staticClass:"explanation"},[_vm._v(_vm._s(_vm.explanation))]),_c(VListItemSubtitle,{staticClass:"pinyin"},[_vm._v("[MAN] "+_vm._s(_vm.pinyin))])],1)],1),_c(VDivider)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }